module.exports = __webpack_public_path__ + "static/mobileLogo.9b4ce605.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobileLogo.png
// module id = 1162
// module chunks = 79611799117203